// extracted by mini-css-extract-plugin
export default {"container":"CandidateResume_container__J4iUe","cv":"CandidateResume_cv__UzJRq"};